document.querySelectorAll("input[data-mash]").forEach((input) => {
    input.value = input.dataset.mash + input.dataset.mash
})